import { render, staticRenderFns } from "./DocumentoValidado.vue?vue&type=template&id=ba532062&scoped=true"
import script from "./DocumentoValidado.vue?vue&type=script&lang=js"
export * from "./DocumentoValidado.vue?vue&type=script&lang=js"
import style0 from "./DocumentoValidado.vue?vue&type=style&index=0&id=ba532062&prod&scoped=true&lang=stylus"
import style1 from "./DocumentoValidado.vue?vue&type=style&index=1&id=ba532062&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba532062",
  null
  
)

export default component.exports